/**
 * Возвращает последние цифры номера счёта в формате `··XXXX`
 * @param accountNumber - Номер счёта.
 * @param additionalParams - Дополнительные параметры.
 * @param additionalParams.countOfResultDigits - Количество оставшихся цифр. По умолчанию 4.
 */
function cropAccountNumber(accountNumber, { countOfResultDigits = 4 } = {}) {
    if (!accountNumber) {
        return accountNumber;
    }
    return `\u00B7\u00B7${accountNumber.slice(-countOfResultDigits)}`;
}

export { cropAccountNumber };
